import { ArrowLeft, CheckCheck, Flag } from "lucide-react";
import { cn } from "@/lib/cn";

export function Header({
  title,
  meta,
  flagged,
  reviewed,
  onExit,
  onReviewed,
}: {
  title: string;
  meta: string;
  flagged: number;
  reviewed: boolean;
  onExit: () => void;
  onReviewed: () => void;
}) {
  return (
    <header className="relative z-[3] flex h-[58px] shrink-0 items-center gap-[var(--space-4)] border-b border-[var(--border-subtle)] bg-[var(--surface-glass-heavy)] px-[var(--space-6)] backdrop-blur-[var(--blur-sm)]">
      <button
        type="button"
        onClick={onExit}
        className="inline-flex items-center gap-1.5 rounded-[var(--radius-md)] px-2 py-1.5 text-[length:var(--text-xs)] text-[var(--text-muted)] transition-colors hover:bg-[var(--surface-glass)] hover:text-[var(--text-primary)]"
      >
        <ArrowLeft size={14} strokeWidth={2} />
        Exit review
      </button>

      <div aria-hidden className="h-[22px] w-px bg-[var(--border-subtle)]" />

      <div className="min-w-0">
        <h1 className="truncate text-[length:var(--text-md)] font-bold tracking-[var(--tracking-snug)]">{title}</h1>
        {/* The handoff also names the engines here ("Scribe v2 + diarization"). They
            come from the configuration store UI-14 builds in M3.3, and inventing them
            now would put a model name in the interface that nothing chose. */}
        <p className="mt-px text-[length:var(--text-2xs)] text-[var(--text-muted)]">{meta}</p>
      </div>

      <div className="ml-auto flex items-center gap-[var(--space-4)]">
        {flagged > 0 && (
          <span className="inline-flex items-center gap-1.5 rounded-[var(--radius-full)] border border-[var(--warning)] px-2.5 py-[3px] text-[length:var(--text-2xs)] text-[var(--warning)]">
            <Flag size={11} strokeWidth={2} />
            {flagged} flagged
          </span>
        )}

        <button
          type="button"
          onClick={onReviewed}
          aria-pressed={reviewed}
          className={cn(
            "inline-flex h-[30px] items-center gap-2 rounded-[var(--radius-md)] px-3 text-[length:var(--text-sm)] font-medium transition",
            reviewed
              ? "border border-[var(--vl-life-soft)] text-[var(--vl-life-soft)] hover:brightness-110"
              : "bg-[var(--primary)] text-[var(--primary-foreground)] hover:brightness-110",
          )}
        >
          <CheckCheck size={14} strokeWidth={2.5} />
          {reviewed ? "Reviewed" : "Mark reviewed"}
        </button>
      </div>
    </header>
  );
}

// ------------------------------------------------------------------ parts (SPCH-14)
